export const commonApiOptions = {
  retry: false,
  refetchOnWindowFocus: false,
  staleTime: 5 * 60 * 1000, // 5 minutes
};
